
<template>
  <div>
    <div class="mb20">
      <el-button type="primary" size='small' @click='onDownLoad(false)'>邀请码</el-button>
    </div>
    <el-table
      class="global-table" stripe
      :data="tableData"
      v-loading="loading">
      <el-table-column label="头像" prop="roleName" minWidth="120px" show-overflow-tooltip>
        <template v-slot="{ row }">
          <el-image :src="row.avatar"
              :preview-src-list="[row.avatar]"
              fit="fill" ref="preview">
        </el-image>
        </template>

      </el-table-column>
      <el-table-column label="昵称" prop="nickName" minWidth="120px" show-overflow-tooltip></el-table-column>
      <el-table-column label="手机号" prop="phone" minWidth="120px" show-overflow-tooltip ></el-table-column>
      <el-table-column label="姓名" prop="ownerName" minWidth="120px" show-overflow-tooltip></el-table-column>
      <el-table-column label="状态" prop="applyStatus" minWidth="120px" show-overflow-tooltip >
        <template v-slot="{ row }">
          {{ row.applyStatus |  getStatusName}}
        </template>
      </el-table-column>
      <el-table-column label="操作" minWidth="120px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="onExamine(row.applyId)" v-show="$ButtonShow('YOA_EDT_01') && row.applyStatus !== '1'">通过</el-button>
          <el-button type="text" @click="onDelete(row.applyId)" v-show="$ButtonShow('YOA_DEL_01')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <global-pagination
      :total="total"
      :current-page.sync="page"
      :page-size.sync="size"
      @current-change="loadData"
      @size-change="loadData"
    ></global-pagination>
    <el-dialog title="审核" :visible.sync="examineShow" width="400px" :before-close="handleClose" :close-on-click-modal='false'>
      <el-form ref="formData" :model="formData"  label-width="120px">
        <el-form-item label="审核结果：" prop="status">
          <el-radio v-model="formData.status" label="1">通过</el-radio>
          <el-radio v-model="formData.status" label="2">未通过</el-radio>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSave" size='small'>确定</el-button>
          <el-button @click="handleClose" size='small'>取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
    title="邀请码"
    width="480px"
    :visible="InvitationCodeShow"
    :close-on-click-modal="false"
    @close="InvitationCodeShow = false"
  >
  <div class="code">
    <el-image class="one" :src="code"></el-image>
      <div style="text-align: center" class="mt20 mb20">
        <el-button type="primary" @click="onDownLoad(true)">下载</el-button>
      </div>
    </div>
  </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Owner',
  components: {
  },
  filters: {
    getStatusName: function (value) {
      // 签到状态 1正常 2缺上班签到 3缺下班签到 4上下班人数不一致
      if (value) {
        if (value === '0') {
          return '待确认'
        } else if (value === '1') {
          return '通过'
        } else {
          return '未申请'
        }
      }
    }
  },
  data () {
    return {
      loading: false,
      tableData: [],
      examineShow: false,
      InvitationCodeShow: false,
      code: '',
      qrType: '1',
      total: 0,
      page: 1,
      size: 10,
      formData: {
        projectId: '',
        status: '1'
      }
    }
  },
  computed: {
  },
  created () {
    this.loadData()
  },
  methods: {
    // 获取项目人员列表
    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.project.selectYhOwnerApplyByPage, {
        projectId: this.$route.query.projectId,
        page: this.page,
        size: this.size
      }).then((res) => {
        this.tableData = res.list || []
        this.total = res.total || 0
        this.loading = false
      })
    },
    // 获取项目人员列表
    addOwner () {
      this.loading = true
      this.$axios.post(this.$apis.project.insertYhOwnerApply, {
        projectId: this.$route.query.projectId,
        ownerName: '智慧养护管家'
      }).then((res) => {
        // this.tableData = res || []
        // this.total = res.total || 0
        // this.loading = false
      })
    },
    // 审核
    onExamine (applyId) {
      // this.examineShow = true
      this.$confirm('确认通过吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
        // center: true
      }).then(() => {
        this.$axios.post(this.$apis.project.updateYhOwnerApplyStatus, { applyId }).then(() => {
          // this.handleClose()
          this.$message.success('操作成功')
          this.loadData()
        })
      })
    },
    handleClose () {
      this.examineShow = false
    },
    // 审核
    onSave () {
      (this.$refs.formData).validate((valid) => {
        if (valid) {
          this.$axios.post(this.$apis.project.insertYhProjectByProjectId, {
            projectId: this.$route.query.projectId,
            status: this.formData.status
          }).then(() => {
            this.$message.success('操作成功')
            this.loadData()
          })
        }
      })
    },
    // 下载
    onDownLoad (preview) {
      this.InvitationCodeShow = true
      this.$axios.get(this.$apis.project.selectOwnerApplyQRCode, {
        projectId: this.$route.query.projectId
      }).then((res) => {
        if (preview) {
          window.location.href = `${res.filePrefix}${res.fileUrl}?attname=${res.fileName}.png`
        } else {
          this.code = '' + res.filePrefix + res.fileUrl
        }
      })
    },
    // 删除
    onDelete (applyId) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
        // center: true
      }).then(() => {
        this.$axios.post(this.$apis.project.deleteYhOwnerApply, { applyId }).then(() => {
          // this.handleClose()
          this.$message.success('删除成功')
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.el-image{
  // width: 100%;
  height:50px
}

.code{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .one{
    width: 300px;
    height: 300px;
  }
}
</style>
